module.exports = __webpack_public_path__ + "static/media/رحلات إلى زيوريخ.e30dc4a9.jpg";